// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AddLinkPermissionData, AddLinkPermissionErrors, AddLinkPermissionResponses, AddTagsBulkData, AddTagsBulkResponses, ArchiveLinkData, ArchiveLinkErrors, ArchiveLinkResponses, ArchiveLinksBulkData, ArchiveLinksBulkErrors, ArchiveLinksBulkResponses, CreateDomainData, CreateDomainErrors, CreateDomainResponses, CreateExampleLinksData, CreateExampleLinksErrors, CreateExampleLinksResponses, CreateFolderData, CreateFolderResponses, CreateLinkCountriesBulkData, CreateLinkCountriesBulkResponses, CreateLinkCountryData, CreateLinkCountryResponses, CreateLinkData, CreateLinkErrors, CreateLinkPublicData, CreateLinkPublicErrors, CreateLinkPublicResponses, CreateLinkRegionData, CreateLinkRegionResponses, CreateLinkRegionsBulkData, CreateLinkRegionsBulkResponses, CreateLinkResponses, CreateLinksBulkData, CreateLinksBulkResponses, CreateLinkSimpleData, CreateLinkSimpleResponses, DeleteLinkCountryData, DeleteLinkCountryResponses, DeleteLinkData, DeleteLinkErrors, DeleteLinkPermissionData, DeleteLinkPermissionErrors, DeleteLinkPermissionResponses, DeleteLinkRegionData, DeleteLinkRegionResponses, DeleteLinkResponses, DeleteLinksBulkData, DeleteLinksBulkResponses, DuplicateLinkData, DuplicateLinkErrors, DuplicateLinkResponses, ExpandLinkData, ExpandLinkErrors, ExpandLinkResponses, GenerateQrCodeData, GenerateQrCodeResponses, GenerateQrCodesBulkData, GenerateQrCodesBulkResponses, GetDomainData, GetDomainErrors, GetDomainResponses, GetFolderData, GetFolderResponses, GetLinkByOriginalUrlData, GetLinkByOriginalUrlResponses, GetLinkCountriesData, GetLinkCountriesResponses, GetLinkData, GetLinkErrors, GetLinkOpengraphData, GetLinkOpengraphResponses, GetLinkPermissionsData, GetLinkPermissionsErrors, GetLinkPermissionsResponses, GetLinkRegionsData, GetLinkRegionsResponses, GetLinkResponses, GetLinksByUrlData, GetLinksByUrlResponses, GetRegionsByCountryData, GetRegionsByCountryResponses, ListDomainsData, ListDomainsResponses, ListFoldersData, ListFoldersResponses, ListLinksData, ListLinksErrors, ListLinksResponses, UnarchiveLinkData, UnarchiveLinkErrors, UnarchiveLinkResponses, UnarchiveLinksBulkData, UnarchiveLinksBulkErrors, UnarchiveLinksBulkResponses, UpdateDomainSettingsData, UpdateDomainSettingsErrors, UpdateDomainSettingsResponses, UpdateLinkData, UpdateLinkErrors, UpdateLinkOpengraphData, UpdateLinkOpengraphResponses, UpdateLinkResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get link opengraph properties
 */
export const getLinkOpengraph = <ThrowOnError extends boolean = false>(options: Options<GetLinkOpengraphData, ThrowOnError>) => (options.client ?? client).get<GetLinkOpengraphResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/opengraph/{domainId}/{linkId}',
    ...options
});

/**
 * Set link opengraph properties
 */
export const updateLinkOpengraph = <ThrowOnError extends boolean = false>(options: Options<UpdateLinkOpengraphData, ThrowOnError>) => (options.client ?? client).put<UpdateLinkOpengraphResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/opengraph/{domainId}/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get link countries
 */
export const getLinkCountries = <ThrowOnError extends boolean = false>(options: Options<GetLinkCountriesData, ThrowOnError>) => (options.client ?? client).get<GetLinkCountriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_country/{linkId}',
    ...options
});

/**
 * Create link country
 */
export const createLinkCountry = <ThrowOnError extends boolean = false>(options: Options<CreateLinkCountryData, ThrowOnError>) => (options.client ?? client).post<CreateLinkCountryResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_country/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create link countries in bulk
 */
export const createLinkCountriesBulk = <ThrowOnError extends boolean = false>(options: Options<CreateLinkCountriesBulkData, ThrowOnError>) => (options.client ?? client).post<CreateLinkCountriesBulkResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_country/bulk/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete link country
 */
export const deleteLinkCountry = <ThrowOnError extends boolean = false>(options: Options<DeleteLinkCountryData, ThrowOnError>) => (options.client ?? client).delete<DeleteLinkCountryResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_country/{linkId}/{country}',
    ...options
});

/**
 * Get link regions
 */
export const getLinkRegions = <ThrowOnError extends boolean = false>(options: Options<GetLinkRegionsData, ThrowOnError>) => (options.client ?? client).get<GetLinkRegionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_region/{linkId}',
    ...options
});

/**
 * Add region targeting to link
 *
 * Add region targeting to link
 */
export const createLinkRegion = <ThrowOnError extends boolean = false>(options: Options<CreateLinkRegionData, ThrowOnError>) => (options.client ?? client).post<CreateLinkRegionResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_region/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all regions by country
 */
export const getRegionsByCountry = <ThrowOnError extends boolean = false>(options: Options<GetRegionsByCountryData, ThrowOnError>) => (options.client ?? client).get<GetRegionsByCountryResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_region/list/{country}',
    ...options
});

/**
 * Create link regions in bulk
 */
export const createLinkRegionsBulk = <ThrowOnError extends boolean = false>(options: Options<CreateLinkRegionsBulkData, ThrowOnError>) => (options.client ?? client).post<CreateLinkRegionsBulkResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_region/bulk/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete link region by country
 */
export const deleteLinkRegion = <ThrowOnError extends boolean = false>(options: Options<DeleteLinkRegionData, ThrowOnError>) => (options.client ?? client).delete<DeleteLinkRegionResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/link_region/{linkId}/{country}/{region}',
    ...options
});

/**
 * Get link permissions
 */
export const getLinkPermissions = <ThrowOnError extends boolean = false>(options: Options<GetLinkPermissionsData, ThrowOnError>) => (options.client ?? client).get<GetLinkPermissionsResponses, GetLinkPermissionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/permissions/{domainId}/{linkId}',
    ...options
});

/**
 * Delete link permissions
 */
export const deleteLinkPermission = <ThrowOnError extends boolean = false>(options: Options<DeleteLinkPermissionData, ThrowOnError>) => (options.client ?? client).delete<DeleteLinkPermissionResponses, DeleteLinkPermissionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/permissions/{domainId}/{linkId}/{userId}',
    ...options
});

/**
 * Add link permission
 */
export const addLinkPermission = <ThrowOnError extends boolean = false>(options: Options<AddLinkPermissionData, ThrowOnError>) => (options.client ?? client).post<AddLinkPermissionResponses, AddLinkPermissionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/permissions/{domainId}/{linkId}/{userId}',
    ...options
});

/**
 * Link list
 *
 * Get domain links
 */
export const listLinks = <ThrowOnError extends boolean = false>(options: Options<ListLinksData, ThrowOnError>) => (options.client ?? client).get<ListLinksResponses, ListLinksErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/links',
    ...options
});

/**
 * Generate QR code for the link
 */
export const generateQrCode = <ThrowOnError extends boolean = false>(options: Options<GenerateQrCodeData, ThrowOnError>) => (options.client ?? client).post<GenerateQrCodeResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/qr/{linkIdString}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate QR codes for the link in bulk
 *
 * Generate QR codes for the link in bulk. Rate limit - 1 request per minute
 */
export const generateQrCodesBulk = <ThrowOnError extends boolean = false>(options: Options<GenerateQrCodesBulkData, ThrowOnError>) => (options.client ?? client).post<GenerateQrCodesBulkResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/qr/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete link
 *
 * Delete link by id
 *
 * **Rate limit**: 20/s
 */
export const deleteLink = <ThrowOnError extends boolean = false>(options: Options<DeleteLinkData, ThrowOnError>) => (options.client ?? client).delete<DeleteLinkResponses, DeleteLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/{link_id}',
    ...options
});

/**
 * Delete links in bulk
 *
 * Delete links in bulk by ids
 *
 * **Rate limit**: 1/s
 */
export const deleteLinksBulk = <ThrowOnError extends boolean = false>(options: Options<DeleteLinksBulkData, ThrowOnError>) => (options.client ?? client).delete<DeleteLinksBulkResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/delete_bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive link
 */
export const archiveLink = <ThrowOnError extends boolean = false>(options: Options<ArchiveLinkData, ThrowOnError>) => (options.client ?? client).post<ArchiveLinkResponses, ArchiveLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive links in bulk
 */
export const archiveLinksBulk = <ThrowOnError extends boolean = false>(options: Options<ArchiveLinksBulkData, ThrowOnError>) => (options.client ?? client).post<ArchiveLinksBulkResponses, ArchiveLinksBulkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/archive_bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unarchive link
 */
export const unarchiveLink = <ThrowOnError extends boolean = false>(options: Options<UnarchiveLinkData, ThrowOnError>) => (options.client ?? client).post<UnarchiveLinkResponses, UnarchiveLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/unarchive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unarchive links in bulk
 */
export const unarchiveLinksBulk = <ThrowOnError extends boolean = false>(options: Options<UnarchiveLinksBulkData, ThrowOnError>) => (options.client ?? client).post<UnarchiveLinksBulkResponses, UnarchiveLinksBulkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/unarchive_bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get link info by link id
 *
 * Get link info by link id. Rate limit: 20/s
 */
export const getLink = <ThrowOnError extends boolean = false>(options: Options<GetLinkData, ThrowOnError>) => (options.client ?? client).get<GetLinkResponses, GetLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/{linkId}',
    ...options
});

/**
 * Update existing URL
 *
 * Update original url, title or path for existing URL by id
 *
 * **Rate limit**: 20/s
 */
export const updateLink = <ThrowOnError extends boolean = false>(options: Options<UpdateLinkData, ThrowOnError>) => (options.client ?? client).post<UpdateLinkResponses, UpdateLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get link info by path
 *
 * Get link info by path. Rate limit: 20/s
 */
export const expandLink = <ThrowOnError extends boolean = false>(options: Options<ExpandLinkData, ThrowOnError>) => (options.client ?? client).get<ExpandLinkResponses, ExpandLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/expand',
    ...options
});

/**
 * Get link info by original URL
 *
 * **DEPRECATED** Get link info by original URL. Rate limit: 20/s
 */
export const getLinkByOriginalUrl = <ThrowOnError extends boolean = false>(options: Options<GetLinkByOriginalUrlData, ThrowOnError>) => (options.client ?? client).get<GetLinkByOriginalUrlResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/by-original-url',
    ...options
});

/**
 * Get links info by original URL
 *
 * Returns all links with the same original URL
 */
export const getLinksByUrl = <ThrowOnError extends boolean = false>(options: Options<GetLinksByUrlData, ThrowOnError>) => (options.client ?? client).get<GetLinksByUrlResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/multiple-by-url',
    ...options
});

/**
 * Create a new link
 *
 * This method creates a new link. If parameter "path" is omitted, it
 * generates path by algorithm, chosen in domain settings.
 *
 * Notes:
 *
 * 1. If URL with a given path already exists and originalURL of the URL in database is equal to originalURL argument, it returns information about existing URL
 * 2. If URL with a given path already exists and originalURL is different from originalURL in database, it returns error with a status `409`
 * 3. If URL with a given originalURL exists, and no path is given, it returns information about existing URL and does not create anything
 * 4. If URL with a given originalURL exists, and custom path is given, it creates a new short URL
 *
 * **Rate limit**: 50/s
 */
export const createLink = <ThrowOnError extends boolean = false>(options?: Options<CreateLinkData, ThrowOnError>) => (options?.client ?? client).post<CreateLinkResponses, CreateLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create a new link (simple version)
 *
 *
 * Simple version of link create endpoint. You can use it if you can not use POST method
 * **Rate limit**: 50/s
 *
 */
export const createLinkSimple = <ThrowOnError extends boolean = false>(options: Options<CreateLinkSimpleData, ThrowOnError>) => (options.client ?? client).get<CreateLinkSimpleResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/tweetbot',
    ...options
});

/**
 * Create a new link using public API key
 *
 * This method creates a new link. Only this method should be used in client-side applications
 *
 * If parameter "path" is omitted, it generates path by algorithm, chosen in domain settings.
 *
 * You can use it with public API key in your frontend applications (client-side javascript, Android & iPhone apps)
 * **Rate limit**: 50/s
 */
export const createLinkPublic = <ThrowOnError extends boolean = false>(options: Options<CreateLinkPublicData, ThrowOnError>) => (options.client ?? client).post<CreateLinkPublicResponses, CreateLinkPublicErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/public',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create up to 1000 links in one call
 *
 * Please use this method if you need to create big packs of links. It
 * accepts up to 1000 links in one API call.
 *
 * It works almost the same as single link creation endpoint, but accepts
 * an array of URLs and returns an array of responses.
 *
 * Returns list of Link objects. If any URL is failed to insert, it returns
 * error object instead as array element. Method is not transactional – it
 * can insert some links from the list and return an error for others.
 *
 * **Rate limit**: 5 queries in 10 seconds
 */
export const createLinksBulk = <ThrowOnError extends boolean = false>(options: Options<CreateLinksBulkData, ThrowOnError>) => (options.client ?? client).post<CreateLinksBulkResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate example links for a domain
 *
 * Creates a set of demo/example links to showcase various features of the short link service.
 *
 * Example links include:
 * - A/B testing with split URLs
 * - Mobile targeting (different URLs for Android/iPhone)
 * - Expiring links with time limits
 * - File download links
 * - Password-protected links
 *
 * **Rate limit**: 5/10s
 */
export const createExampleLinks = <ThrowOnError extends boolean = false>(options: Options<CreateExampleLinksData, ThrowOnError>) => (options.client ?? client).post<CreateExampleLinksResponses, CreateExampleLinksErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/examples',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate an existing link
 *
 * Duplicates an existing link with all its properties, targeting rules, and settings.
 * The duplicated link will have a new random path (or custom if provided) and be fully independent.
 *
 * **Rate limit**: 50/s
 */
export const duplicateLink = <ThrowOnError extends boolean = false>(options: Options<DuplicateLinkData, ThrowOnError>) => (options.client ?? client).post<DuplicateLinkResponses, DuplicateLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/duplicate/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List domains
 *
 * Shows all domains of current user
 */
export const listDomains = <ThrowOnError extends boolean = false>(options?: Options<ListDomainsData, ThrowOnError>) => (options?.client ?? client).get<ListDomainsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/domains',
    ...options
});

/**
 * Get domain details by id
 */
export const getDomain = <ThrowOnError extends boolean = false>(options: Options<GetDomainData, ThrowOnError>) => (options.client ?? client).get<GetDomainResponses, GetDomainErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/domains/{domainId}',
    ...options
});

/**
 * Update domain settings
 *
 * Update domain settings
 */
export const updateDomainSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateDomainSettingsData, ThrowOnError>) => (options.client ?? client).post<UpdateDomainSettingsResponses, UpdateDomainSettingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/domains/settings/{domainId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Append a single tag to the links in bulk
 */
export const addTagsBulk = <ThrowOnError extends boolean = false>(options: Options<AddTagsBulkData, ThrowOnError>) => (options.client ?? client).post<AddTagsBulkResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a domain
 */
export const createDomain = <ThrowOnError extends boolean = false>(options: Options<CreateDomainData, ThrowOnError>) => (options.client ?? client).post<CreateDomainResponses, CreateDomainErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/domains',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get links folders for the specified domain id
 */
export const listFolders = <ThrowOnError extends boolean = false>(options: Options<ListFoldersData, ThrowOnError>) => (options.client ?? client).get<ListFoldersResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/folders/{domainId}',
    ...options
});

/**
 * Get links folder for the specified domain id and user id
 */
export const getFolder = <ThrowOnError extends boolean = false>(options: Options<GetFolderData, ThrowOnError>) => (options.client ?? client).get<GetFolderResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/folders/{domainId}/{folderId}',
    ...options
});

/**
 * Create a new folder
 */
export const createFolder = <ThrowOnError extends boolean = false>(options: Options<CreateFolderData, ThrowOnError>) => (options.client ?? client).post<CreateFolderResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/links/folders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
